import React, { useState } from 'react'
import { Header, Table, Button, Icon, Item, Grid } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";

import "./AccommodationPriceHistory.css"

const AccommodationPriceHistory = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<>
        <Header as='h3'>{t("property:PriceHistory")}</Header>
        <Table singleLine>
    <Table.Header>
      <Table.Row>

			
        <Table.HeaderCell width={4}>{t("property:Date")}</Table.HeaderCell>
        <Table.HeaderCell width={4}>{t("property:Price")}</Table.HeaderCell>
        <Table.HeaderCell width={4}>{t("property:Event")}</Table.HeaderCell>
        <Table.HeaderCell width={4}>{t("property:Source")}</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      <Table.Row>
      			
        <Table.Cell>03/22/2022</Table.Cell>
        <Table.Cell>$355,200</Table.Cell>
        <Table.Cell>Listed For Sale</Table.Cell>
        <Table.Cell>Zillow Offers #142318</Table.Cell>
      </Table.Row>
     
    </Table.Body>
  </Table>
    </>
    )
}
export default AccommodationPriceHistory